module.exports = "pegasus/assets/sandwich-bg.png";